import { ActivityProps, BlockContent } from '~/bootcamp/Activities/types/activities.types'
import { AppLanguage } from '~/types/locale'

import { SanityDataTypes } from '../../MatchingPairs/utils/data.matchingPairs'

export interface OrderElementsProps extends ActivityProps {
  questions: OrderElementsQuestion[]
}

export interface OrderElementsActivityData {
  question: OrderElementsQuestion
  questionIndex: number
}

export interface OrderElementsQuestionMessageData {
  elements?: []
}

export interface OrderElementsMessage {
  type?: string
  questionMessageData?: OrderElementsQuestionMessageData
  language?: AppLanguage
}

export interface OrderElementsQuestion {
  question: BlockContent[]
  elements: Array<{ element: BlockContent[] }>
  questionId: string
  _key: string // Uniquely defines a object
}

export enum OrderElementsAnswerType {
  WRONG = 'wrong',
  CORRECT = 'correct',
  SELECT_CORRECT = 'select-correct',
  SELECT_ALL_CORRECT = 'select-all-correct',
  SELECT_ONLY_CORRECT = 'select-only-correct',
}

export interface Column {
  id: number
  categoryName: string
  position: number
}

export interface Task {
  id: number
  position: number
  categoryName: string
  content: BlockContent[]
  contentType: SanityDataTypes
  check: boolean
  taskStatus: TaskStatus
}

export enum TaskStatus {
  Right = 'Right',
  Wrong = 'Wrong',
  Unchecked = 'Unchecked',
  Checking = 'Checking',
  ReadyToCheck = 'ReadyToCheck',
  Reset = 'Reset',
}
